/** 입력값에서 숫자·소수점만 추출 (콤마 제거) */
export function parseAmountInput(value: string): string {
  const cleaned = value.replace(/,/g, '').replace(/[^\d.]/g, '')
  const parts = cleaned.split('.')
  if (parts.length <= 1) {
    return parts[0] ?? ''
  }
  return `${parts[0]}.${parts.slice(1).join('')}`
}

/** 매출액 표시용 (천 단위 콤마, 소수는 필요할 때만 최대 2자리) */
export function formatAmountDisplay(
  value: string | number | null | undefined,
): string {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  const raw =
    typeof value === 'string' ? parseAmountInput(value) : String(value)
  if (!raw) {
    return ''
  }

  const num = Number(raw)
  if (!Number.isFinite(num)) {
    return ''
  }

  const hasFraction = Math.round(num * 100) % 100 !== 0

  return num.toLocaleString('ko-KR', {
    maximumFractionDigits: hasFraction ? 2 : 0,
  })
}

/** API 저장용 — 콤마 제거 후 문자열 */
export function normalizeAmountForSave(
  value: string | number | null | undefined,
): string {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  if (typeof value === 'number') {
    return String(value)
  }

  return parseAmountInput(value)
}
